import React, { PureComponent } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

class SelectField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      label: PropTypes.string,
    })),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
        label: PropTypes.string,
      }),
      PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
        label: PropTypes.string,
      })),
    ]).isRequired,
    defaultValue: PropTypes.number,
    isMulti: PropTypes.bool,
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.string,
    menuIsOpen: PropTypes.bool,
    isDisabled: PropTypes.bool,
  };

  static defaultProps = {
    placeholder: '',
    defaultValue: 0,
    options: [],
    isMulti: false,
    isClearable: false,
    isSearchable: 'true',
    menuIsOpen: undefined,
    isDisabled: false,
  };

  handleChange = (selectedOption) => {
    const { onChange, isMulti, name } = this.props;
    if (isMulti) {
      onChange({ selectedOptions: selectedOption, name, isMulti });
      return;
    }

    onChange({ ...selectedOption, name, isMulti });
  };

  render() {
    const {
      value, defaultValue, name, placeholder, options, isMulti,
      isClearable,
      isSearchable,
      menuIsOpen,
      isDisabled,
    } = this.props;

    // const styles = {
    //   option: base => ({
    //     ...base,
    //     // borderBottom: `1px dotted ${'white'}`,
    //     padding: '8px 2px',
    //     alignTtems: 'center;',
    //     display: 'flex;',
    //     boxSizing: 'content-box',
    //   }),
    //   multiValue: (base, state) => (state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base),
    //   multiValueLabel: (base, state) => (
    //     state.data.isFixed
    //       ? {
    //         ...base,
    //         fontWeight: 'bold',
    //         color: 'white',
    //         paddingRight: 6,
    //       }
    //       : base
    //   ),
    //   multiValueRemove: (base, state) => (
    //     state.data.isFixed ? { ...base, display: 'none' } : base
    //   ),
    //   menu: ({ width, ...css }) => ({
    //     ...css,
    //     // width: '200px',
    //   }),
    // };

    const optionStyles = {
      option: base => ({
        ...base,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.25',
        height: 'auto',
        minHeight: 'unset',
        display: 'block',
        paddingTop: '8px',
        paddingBottom: '8px',
      }),
      menu: base => ({
        ...base,
        minWidth: '100%',
        width: 'max-content',
        maxWidth: '400px',
      }),
      menuList: base => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
      }),
    };

    return (
      <Select
        menuPlacement="auto"
        styles={optionStyles}
        name={name}
        value={value}
        onChange={this.handleChange}
        options={options}
        defaultValue={defaultValue}
        clearable={false}
        className={isMulti ? 'basic-multi-select' : 'single-select'}
        placeholder={placeholder}
        // classNamePrefix="select"
        classNamePrefix="react-select"
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        menuIsOpen={menuIsOpen}
        isDisabled={isDisabled}
      />
    );
  }
}

const renderSelectField = (props) => {
  const {
    input, meta, options, placeholder, defaultValue, className, isMulti,
    isClearable,
    isSearchable,
    menuIsOpen,
    isDisabled,
    addDefaultOption,
    onChange,
  } = props;

  const opts = (typeof options === 'function' ? options() : options).slice();
  if (addDefaultOption) {
    if (!opts.find(o => o.value === 0)) {
      opts.unshift({ value: 0, label: '-' });
    }
  }

  const handleChange = (value) => {
    input.onChange(value);
    if (typeof onChange === 'function') {
      onChange(value);
    }
  };

  return (
    <div className={`form__form-group-input-wrap ${className}`}>
      <SelectField
        {...input}
        onChange={handleChange}
        options={opts}
        placeholder={placeholder}
        defaultValue={defaultValue}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        menuIsOpen={menuIsOpen}
        isDisabled={isDisabled}
      />
      {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
    </div>
  );
};

renderSelectField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.string,
  })),
  placeholder: PropTypes.string,
  defaultValue: PropTypes.number,
  className: PropTypes.string,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.string,
  menuIsOpen: PropTypes.bool,
  isDisabled: PropTypes.bool,
  addDefaultOption: PropTypes.bool,
  onChange: PropTypes.func,
};

renderSelectField.defaultProps = {
  meta: null,
  options: [],
  placeholder: '',
  defaultValue: 0,
  className: '',
  isMulti: false,
  isClearable: false,
  isSearchable: 'true',
  menuIsOpen: undefined,
  isDisabled: false,
  addDefaultOption: true,
  onChange: undefined,
};

export default renderSelectField;
